import getPageName from "../../helpers/track/getPageName";
import { trackEvent } from "../../track";

const test = ({ target }) => target.closest(".reviews, [data-bv-show='reviews'], #review_section");

const push = ({ target }) => {
    const productName = target.closest(".reviews, [data-bv-show='reviews'], #review_section")?.dataset?.gtmProductname;
    const shadowRoot = target?.shadowRoot;
    const activeElement = shadowRoot ? shadowRoot?.activeElement : null;
    const isStarRate = activeElement? activeElement?.classList.contains("bv-reviews-product-rating-star") : false;
    const isPopClose = activeElement? activeElement?.classList.contains("PopoverClose") : false;

    if (!activeElement || isPopClose) return;

    if (isStarRate) {
      trackEvent({
          'event': 'click_add_review',
          'event_type': 'click',
          'item_name': productName?.replace(/<[^>]*>/g, '') || getPageName() || '',
      });
    } else {
      trackEvent({
          'event': 'click_read_review',
          'event_type': 'click',
          'item_name': productName?.replace(/<[^>]*>/g, '') || getPageName() || '',
      });
    }
}

export default {
  name: "bv-reviews",
  test,
  push
};